import AutocompleteInput from 'app/components/AutocompleteInput';

const QuickEditAutocomplete = props => {
  const {
    inputProps,
    inputOptions,
    getInputOptions,
    selectedOptionFormatter,
    data,
    value
  } = props;

  let variant = 'filled';
  let size = 'small';
  let inputSx = inputProps.sx;
  //let onChange = (event, option) => {
  //  console.log(option);
  //}

  inputSx.input.padding = '1rem !important';
  inputSx.height = '2.4rem !important';
  inputSx.borderRadius = '4px !important';
  inputSx.background = '#f3f3fe !important';
  inputSx['&::after'] = {
    borderBottom: 'none !important'
  }

  // seed initial value.
  // if selected option is passed then the autocomplete won't
  // fire a request to get the options.
  // this is important for quick edit mode
  let initialValue = null,
    selectedOption = null;

  if (selectedOptionFormatter) {
    selectedOption = selectedOptionFormatter(data);
  } else {
    initialValue = value;
  }

  return (
    <AutocompleteInput
      initialValue={initialValue}
      selectedOption={selectedOption}
      inputOptions={inputOptions}
      getInputOptions={getInputOptions}
      variant={variant}
      size={size}
      inputSx={inputSx}
      //onChange={onChange}
    />
  );
}

export default QuickEditAutocomplete;
